import { custom } from "./utilities";
import { globalConstants } from "../../constants";

const { SET_SAVE_CHANGES, IS_CONFORMATION_MODAL, SET_SELECTED_ROW_ID } =
  globalConstants;

const setSaveChanges = (flag) => {
  return (dispatch) => dispatch(custom(flag, SET_SAVE_CHANGES));
};

const setIsConfirmationModal = (flag) => {
  return (dispatch) => dispatch(custom(flag, IS_CONFORMATION_MODAL));
};

const setSelectedRowId = (id) => {
  return (dispatch) => dispatch(custom(id, SET_SELECTED_ROW_ID));
};

export const systemActions = {
  setSaveChanges,
  setSelectedRowId,
  setIsConfirmationModal,
};
